import * as z from "zod";

export const createCheckoutSession = {
  name: "createCheckoutSession" as const,
  input: z.object({}),
  output: z.object({ checkoutSessionId: z.string() }),
};
